import { FormText } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWarning } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";

export default function OwnNavigationDisabledWarning() {
  const { t } = useTranslation();

  return (
    <div className="mt-1">
      <FormText>
        <FontAwesomeIcon icon={faWarning} className="me-1 text-warning" />
        {t("carousel.live.ownNavigationDisabled")}
      </FormText>
    </div>
  );
}
